<template>
    <div class="card">
        <div class="card-header">
            {{trans('tasks.cards.header.tracking')}}
            <button class="btn btn-secondary pull-right" @click="add">Add</button>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12" :key="taskTracker" v-for="taskTracker in taskTrackers">
                    <task-tracker @remove="removeTaskTracker" :id="taskTracker" :task="task">

                    </task-tracker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let moment = require('moment');

    export default {
        name: 'task-trackers',
        props: {
            task: Object,
        },
        data() {
            return {
                taskTrackers: []
            }
        },
        mounted() {
            this.loadExistingTrackers();

            this.listenForChanges();
        },
        watch: {
            taskTrackers(newValue){
                this.$emit('updated', newValue);
            }
        },
        methods: {
            trans: function (path) {
                return Lang.trans(path);
            },
            removeTaskTracker(id){
                this.taskTrackers = _.filter(this.taskTrackers, function(taskTracker){
                    return taskTracker !== id;
                });
                Vue.ls.set('tasks.' + this.task.id + '.trackers', this.taskTrackers);
            },
            listenForChanges() {
                let vm = this;
                Vue.ls.on('tasks.' + this.task.id + '.trackers', function (taskTrackers) {
                    vm.taskTrackers = taskTrackers;
                });
            },
            loadExistingTrackers() {
                this.taskTrackers = Vue.ls.get('tasks.' + this.task.id + '.trackers', []);
            },
            add() {
                let id = 'tracker_' + moment().format('YYYY-MM-DD-HH-mm-ss');
                this.taskTrackers = Vue.ls.get('tasks.' + this.task.id + '.trackers', []);
                this.taskTrackers.push(id);
                Vue.ls.set('tasks.' + this.task.id + '.trackers', this.taskTrackers);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskTrackers.vue